
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reader-personality-test",
      function () {
        return require("private-next-pages/reader-personality-test/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reader-personality-test"])
      });
    }
  